import React, { useState } from 'react';
import './solutions.scss';
import { useParams } from 'react-router-dom';
import Typing from 'react-typing-animation'
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';
import Flash from 'react-reveal/Flash';
import { MathComponent } from 'mathjax-react'
import { CopyBlock, dracula } from "react-code-blocks";
import { problem_1a, problem_1b, TopBar } from "../../snippets";



const One = (props) => {
  const [language, changeLanguage] = useState("JavaScript");
  const [language_b, changeLanguage_b] = useState("JavaScript");
  const [languageDemo, changeDemo] = useState(problem_1a["JavaScript"]);
  const [languageDemo_b, changeDemo_b] = useState(problem_1b["JavaScript"]);
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const [process, setProcess] = useState(false);
  const [maxNum, setMaxNum] = useState(1000);
  const [scaleProcess, setScaleProcess] = useState(false);
  const [maxNumScale, setMaxNumScale] = useState(900000000);
  const [multiple1, setMultiple1] = useState(3);
  const [multiple2, setMultiple2] = useState(5);


  //let { id } = useParams();
  const load = JSON.stringify(props.dataLoad)
  const id = props.idLoad
  console.log(id)

  //problem implementation logic
  const runProcess = (n)=>{
      var t0 = performance.now();
      let sum = 0
      let multiples = []
      for (let i=1; i<n; i++){
          if((i%3 == 0) || (i%5 == 0)){
              sum = sum + i;
              multiples.push(i)
          }
      }
      var t1 = performance.now();
      console.log(`Call to runProcess took ${t1 - t0} milliseconds.`);
      return sum;
    }

    const shoot = () =>{
      setProcess(true)
    }

    const runProcessScale = (n, m1, m2) =>{
      var t0 = performance.now();
      let sum = multiplesSum(n, m1) + multiplesSum(n, m2) - multiplesSum(n, m1*m2);
      console.log(`Call to runProcess took ${performance.now() - t0} milliseconds.`);
      return sum;
    }

    const multiplesSum = (n, m) =>{
      n = n-1
      let x = Math.floor(n/m)
      let sum = m * (x/2) * (x+1)
      return sum
  }

    const shootScale = () =>{
      setScaleProcess(true)
    }

    /*const MathJax = {
        tex: {inlineMath: [['$', '$'], ['\\(', '\\)']]},
        chtml: {
          displayAlign: 'left'
        },
        startup: {
          pageReady: function () {
            //
            //  Do the usual startup (which does a typeset).
            //  When that is all done, un-hide the page.
            //
            return MathJax.startup.defaultPageReady().then(function () {
              document.getElementById("hidden").disabled = true;
            });
          }
        }
      };

      (function () {
        var n = 1;
    
        //
        //  Make the current step be visible, and increment the step.
        //  If it is the last step, disable the step button.
        //  Once a step is taken, the reset button is made available.
        
        window.ShowStep = function () {
          document.getElementById("Step" + n++).style.visibility = "visible";
          if (!document.getElementById("Step" + n)) {
            document.getElementById("step").disabled = true;
          }
          document.getElementById("reset").disabled = false;
        }
    
        //
        //  Enable the step button and disable the reset button.
        //  Hide the steps.
    
        window.ResetSteps = function () {
          document.getElementById("step").disabled = false;
          document.getElementById("reset").disabled = true;
          var i = 1, step; n = 1;
          while (step = document.getElementById("Step" + i)) {
            step.style.visibility = "hidden";
            i++
          }
        }
      })();

      */

      return(
        <div className="solution-render">
            <p>We can use <i>mod</i> operator to check for even divisibility while we loop through the range of integers between 1 and 1000. The integers(i) that are divisible by 3 or 5 are summed up in each iteration.</p>
              <div>
                  <Zoom left>
                    <TopBar
                      language={{
                        value: language,
                        onChange: e => {
                          changeDemo(problem_1a[e.target.value]);
                          return changeLanguage(e.target.value);
                        },
                        options: Object.keys(problem_1a).map(lang => (
                          <option key={lang} value={lang}>
                            {lang}
                          </option>
                        ))
                      }}
                      toggle={{
                        checked: lineNumbers,
                        onChange: e => toggleLineNumbers(!lineNumbers)
                      }}
                    />
                    <CopyBlock
                      language={language}
                      text={languageDemo}
                      showLineNumbers={lineNumbers}
                      theme={dracula}
                      wrapLines={true}
                      codeBlock
                    />   
                
                </Zoom>
              </div>            
            <div>
              <br />
              <div>
              <p>
                This solution may not scale for larger maximum numbers
              </p>
              </div>
              <div class="test-form">
                  <div class="my-form">
                    <h4 class="brand-title">Let's try it out</h4>
                    <p>
                      Calculating for maximum number to the tune of 900,000,000 may crash the browser. 
                    </p>
                    <div class="inputs">
                      <input 
                        type="number"
                        placeholder="Enter a maximum number" value={maxNum}
                        onChange={(e) => {
                          setMaxNum(e.target.value)
                          setProcess(false)

                          } 
                        }
                      />
                      <button type="submit"  onClick={shoot}>PROCESS</button>
                    </div>
                  </div>
              </div>
              <br />
              {process ? (
                  <p>
                    <Flip>
                      <div class="content-card" align="center">
                        <div class="card-big-shadow">
                            <div class="card card-just-text" data-background="color" data-color="blue" data-radius="none">
                                <div class="card-content">
                                    <h4 class="description">Result</h4>
                                    <h5 class="title"><p>The sum of all the multiples of 3 or 5 below {maxNum} is <b id="value">{runProcess(maxNum)}</b></p></h5>                              
                                </div>
                            </div>
                        </div>
                      </div>
                    </Flip>
                  </p>
              ) : (
                <p> <br /> </p>
              )}
                  <h5>
                    We can use the Gauss's formula to scale this solution for larger maximum numbers
                  </h5>
                  <p>
                      As formulated by Carl Friedrich Gauss (one of the most prolific mathematicians of all time),
                      
                      <MathComponent tex={String.raw`{1+2+3+…+n} = `} />
                      <MathComponent tex={String.raw`{1 \over 2}*n*(n+1)`} />
                  </p>
                  <p>
                      Below is how the formula was derived:
                        Adding first 100 terms,
                        <MathComponent tex={String.raw`{1 + 2 + 3 + 4 + ... + 97 + 98 +}`} />
                        <MathComponent tex={String.raw`{99 + 100}`} />

                        The sum of the first n integers then becomes:
                        <MathComponent tex={String.raw`{1 + 2 + 3 + 4 + ... + (n-3) +}`} />
                        <MathComponent tex={String.raw`{(n-2) + (n-1) + n}`} />
                  </p>
                  <p>
                        Adding these terms, we have:
                        <MathComponent tex={String.raw`{...+ (n-3)+4 + (n-2)+}`} />
                        <MathComponent tex={String.raw`{3 + (n-1)+2 + n + 1}`} />
                        This gives:
                        <MathComponent tex={String.raw`{n+1 + n+1 + ... +}`} />
                        <MathComponent tex={String.raw`{ n+1 + n+1.}`} />
                        i.e.:
                        <MathComponent tex={String.raw`{({n \over 2} \; terms \; of \; (n+1))}`} />
                        Hence the Gaussian formula:
                        <MathComponent tex={String.raw`{\sum_{n=1}^n} = {{n \over 2}*(n+1)}`} />

                        For sum of natural numbers from 1 to 10;
                        n=10.
                        <MathComponent tex={String.raw`{\sum_{n=1}^{10}} = {{10\over2}*(10+1)} = 55` } />

                        i.e:
                        <MathComponent tex={String.raw`{(i.e. 1+2+3+4+5+6+}` } />
                        <MathComponent tex={String.raw`{7+8+9+10)}` } />

                        For sum of natural numbers &lt;= 35:
                        n = 35.
                        <MathComponent tex={String.raw`{\sum_{n=1}^{35}} = {35*{(35+1) \over 2}} = 630` } />
                        
                        We can as well find the sum of multiples of a number up to an upper bound limit,
                        For example, the sum of multiples of 3 &lt;= 35 will follow this pattern;
                        <MathComponent tex={String.raw`{3 + 6 + 9 + 12 + 15 + 18 + }`} />
                        <MathComponent tex={String.raw`{ 21 + 24 + 27 + 30 + 33 = 198}`} />

                        <br />
                        <MathComponent tex={String.raw`{3(1 + 2 + 3 + 4 + 5 + 6 + 7 +)}` } />
                        <MathComponent tex={String.raw`{ 8 + 9 + 10 + 11)}` } />

                        <br />
                        <MathComponent tex={String.raw`{= 3*66 = 198}` } />

                        Applying the Gaussian method, we have... 
                        <br /> 
                        <MathComponent tex={String.raw`{Sum = 3*({n\over2}*(n+1))}`} />
                        new n becomes 11
                        <br /><br />
                        Hence we have:
                        <MathComponent tex={String.raw`{Sum = 3*11*{(11+1) \over 2}} =}`} />

                        <MathComponent tex={String.raw`{3 * 11 * 6 = 198}`} />
                       
                        Generally, we can represent this with the Gaussian formula as well.
                        <br /><br />
                        Let m represent the number we are adding its multiples (3 in this case)

                        <MathComponent tex={String.raw`{x = new \; n = {n \over m} = {35 \over 3} = 11.6}`} />

                        <MathComponent tex={String.raw`{ = 11 \;(taking \; the \; integer \; only)}`} />
                        
                        Hence, the Gaussian formula becomes:
                        <MathComponent tex={String.raw`{Sum = m*{x \over 2}*(x+1) = }` } />

                        <MathComponent tex={String.raw`{3*11*{12 \over 2} = 198.}` } />

                        To find the sum of multiples of 3 or 5 below 1000, we add the sum of multiples of 3 to sum of multiples of 5 then subtract the sum of multiples of 3 & 5 (to avoid overage/repetition). <br />

                        Sum of multiples of 3: <br />
                        n = 999; m = 3; x = n/m = 999/3 =  333
                        <MathComponent tex={String.raw`{Sum = m*{x \over 2}*(x+1) = }`} />
                        <MathComponent tex={String.raw`{3*333*{334 \over 2} = 166833}`} />

                        Sum of multiples of 5: <br />
                        n = 999; m= 5; x = n/m = 999/5 =  199 ( taking the integer only/math.floor)
                        <MathComponent tex={String.raw`{Sum = m*{x \over 2}*(x+1) = }` } />
                        <MathComponent tex={String.raw`{5*199*{200 \over 2} = 99,500}` } />

                        Sum of multiples of 3 & 5:<br />
                        n = 999; m= 15; x = n/m = 999/15 =  66 ( taking the integer only/math.floor)
                        <MathComponent tex={String.raw`{Sum =m*{x \over 2}*(x+1) =}`} />
                        <MathComponent tex={String.raw`{15*{66 \over 2}*67 = 33165}`} />

                        <br />
                        The sum of multiples of 3 or 5 will be:<br />
                         ((sum of multiples of 3 + sum of multiples of 5) - (minus Sum of multiples of 3 & 5)) <br /><br />
                        Hence the sum of multiples of 3 or 5 below 1000 = 166833 + 99500 -33165 = <strong>233168</strong> 
                        <br />
                        </p>
                        The snippets below can be used to implement this:
                        <div>
                            <Zoom>
                              <TopBar
                                language={{
                                  value: language_b,
                                  onChange: e => {
                                    changeDemo_b(problem_1b[e.target.value]);
                                    return changeLanguage_b(e.target.value);
                                  },
                                  options: Object.keys(problem_1b).map(lang => (
                                    <option key={lang} value={lang}>
                                      {lang}
                                    </option>
                                  ))
                                }}
                                toggle={{
                                  checked: lineNumbers,
                                  onChange: e => toggleLineNumbers(!lineNumbers)
                                }}
                              />
                              <CopyBlock
                                language={language_b}
                                text={languageDemo_b}
                                showLineNumbers={lineNumbers}
                                theme={dracula}
                                wrapLines={true}
                                codeBlock
                              />                            
                          </Zoom>
                        </div>
                        <br />
                                        
                        <div class="test-form">
                          <div class="my-form">
                            <h4 class="brand-title">Let's practicalize this</h4>
                              <p>
                                Calculating for maximum number to the tune of 900,000,000 will not crash the browser. 
                              </p>
                                <div class="inputs">
                                  <label>First factor (m2):</label>
                                  <input
                                    type="number"
                                    placeholder="Enter the first factor" value={multiple1}
                                    onChange={(e) => {
                                      setMultiple1(e.target.value)
                                      setScaleProcess(false)
                                    }}
                                    />
                                  <br />
                                  <label>Second factor (m2):</label>
                                  <input
                                    type="number"
                                    placeholder="Enter the second factor" value={multiple2}
                                    onChange={(e) => {
                                      setMultiple2(e.target.value)
                                      setScaleProcess(false)
                                    }}
                                    />
                                    <br />
                                  <label>Maximum number (n):</label>
                                  <input 
                                    type="number"
                                    placeholder="Enter a maximum number" value={maxNumScale}
                                    onChange={(e) => {
                                      setMaxNumScale(e.target.value)
                                      setScaleProcess(false)

                                      } 
                                    }
                                  />
                                  <br />
                                  <button type="submit"  onClick={shootScale}>PROCESS</button>
                                </div>
                                <br />
                              </div>
                            </div>
                            <div>
                              <br />
                            {scaleProcess ? (
                                <p>
                                  <Flash>
                                  <div class="content-card" align="center">
                                    <div class="card-big-shadow">
                                        <div class="card card-just-text" data-background="color" data-color="blue" data-radius="none">
                                            <div class="card-content">
                                              <h4 class="description">Result</h4>
                                                <h5 class="title">
                                                  <p>The sum of all the multiples of {multiple1} or {multiple2} below {maxNumScale} is <b id="value2">{runProcessScale(maxNumScale, multiple1, multiple2)}</b></p>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                  </Flash>
                                </p>
                            ) : (
                              <p> <br /> </p>
                            )}
                            </div>
                          </div>
                          <br/>
                      </div>
    )
}
export default One;